import csvData from "./fem-friendly-survey.js";
export const allSurveys = csvData.filter((obj) => obj["ID"].length).map((entryObj) => Object.entries(entryObj).map(([key, value]) => [
  "id",
  "tenure_total_num",
  "tenure_women_num",
  "grad_total_num",
  "grad_women_num",
  "postdoc_total_num",
  "postdoc_women_num"
].includes(key.toLowerCase()) ? {
  [key.toLowerCase()]: parseInt(value)
} : key === "IS_ACTIVE" ? {
  [key.toLowerCase()]: value === "true" ? true : false
} : {
  [key.toLowerCase()]: value
}).reduce((acc, el) => ({...acc, ...el})));
export const surveyDict = allSurveys.map((survey) => ({[survey.id]: survey})).reduce((acc, el) => ({...acc, ...el}), {});
